module.exports = __webpack_public_path__ + "static/media/FontAwesome5_Regular.f6c6f6c8.ttf";